import CycleMeasurement from '../enums/cycle-measurement';

const toNumberOrOriginal = (value: unknown): number | unknown => {
  if (value === '' || value === null || value === undefined) {
    return value;
  }

  const numberValue = Number(value);

  return Number.isFinite(numberValue) ? numberValue : value;
};

const roundConvertedValue = (value: number): number => Math.round(value);

// Storing whole-degree Celsius loses precision when the source value is a Fahrenheit
// delta (5/9 per degree F is not an integer), so two adjacent Fahrenheit values can
// round to the same Celsius value and the wrong one comes back after a reload. Keeping
// one decimal place of Celsius precision is enough to make every whole-degree Fahrenheit
// value round-trip back to itself.
const roundConvertedValueForStorage = (value: number): number => Math.round(value * 10) / 10;

export const convertAbsoluteTemperature = (value: unknown, from: CycleMeasurement, to: CycleMeasurement): unknown => {
  const numberValue = toNumberOrOriginal(value);

  if (typeof numberValue !== 'number' || from === to) {
    return numberValue;
  }

  if (from === CycleMeasurement.Celsius && to === CycleMeasurement.Fahrenheit) {
    return roundConvertedValue((numberValue * 9) / 5 + 32);
  }

  return roundConvertedValue(((numberValue - 32) * 5) / 9);
};

export const convertTemperatureDelta = (value: unknown, from: CycleMeasurement, to: CycleMeasurement): unknown => {
  const numberValue = toNumberOrOriginal(value);

  if (typeof numberValue !== 'number' || from === to) {
    return numberValue;
  }

  if (from === CycleMeasurement.Celsius && to === CycleMeasurement.Fahrenheit) {
    return roundConvertedValue((numberValue * 9) / 5);
  }

  // Converting Fahrenheit -> Celsius here always means "about to be saved" throughout
  // this app, so round-trip precision matters more than a clean whole number.
  return roundConvertedValueForStorage((numberValue * 5) / 9);
};
